import React, { Component }    from 'react';
import PlaceListView           from './PlaceListView';
import PlaceGridView           from './PlaceGridView';
import PlaceMapView            from './../containers/PlaceMapViewContainer';
import { LIST_VIEW, MAP_VIEW } from './../actions/ViewAction';
import ToggleView              from './../containers/SwitchViewContainer'
import Closest                 from './../containers/ClosestContainer';

import './../css/PlaceList.css';

class PlaceList extends Component {

    render = () => {
        if (0 === this.props.places.length || LIST_VIEW === this.props.viewType) {
            return (
                <div>
                    <div className="toggle-view-h">
                        <div className="toggle-h">
                            <ToggleView />
                        </div>
                        <div className="closest-h">
                            <Closest version="small" />
                        </div>
                    </div>
                    <PlaceListView key="list-view" geo={ this.props.geo } theme={ this.props.theme } places={ this.props.places } filter={ this.props.filter }/>
                    <PlaceGridView key="grid-view" geo={ this.props.geo } theme={ this.props.theme } places={ this.props.places } filter={ this.props.filter } />
                </div>
            );
        }
        else if (MAP_VIEW === this.props.viewType)
        {
            return (
                <div>
                    <div className="toggle-view-h">
                        <div className="toggle-h">
                            <ToggleView />
                        </div>
                        <div className="closest-h">
                            <Closest version="small" />
                        </div>
                    </div>
                    <PlaceMapView { ...this.props } />
                </div>)
        }
    }
}

export default PlaceList;


// WEBPACK FOOTER //
// ./src/components/PlaceList.js